import { jsonApi } from '@models/jsonApi';

jsonApi.define('browser-language', {
  id: null,
  code: '',
  language: '',
});
